import { useMediaQuery, useTheme } from '@mui/material';

import EarlyBirdImgLarge from '../../images/early-bird-large.png';
import EarlyBirdImgMedium from '../../images/early-bird-medium.png';
import styles from './ProxyPromoContent.module.scss';

type Props = {
    heading: string;
    content: string | string[];
    isBulletList: boolean;
};

const ProxyPromoImage = ({ isTablet }) => {
    const imageUrl = isTablet ? EarlyBirdImgMedium : EarlyBirdImgLarge;

    return (
        <div
            style={{ backgroundImage: `url(${imageUrl})` }}
            className={styles['proxy-content-image']}></div>
    );
};

const ProxyPromoContent = ({ heading, content, isBulletList }: Props) => {
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const headingSize = isMobile ? 'xlarge' : 'xxlarge';

    return (
        <section className={styles['proxy-content']}>
            <div className={styles['proxy-content-container']}>
                <div className={styles['proxy-content-main']}>
                    <div className={styles['proxy-content-heading']}>
                        <hzn-heading as="h1" size={headingSize} line-height="xsmall">
                            {heading}
                        </hzn-heading>
                    </div>
                    <div className={styles['sub-container']}>
                        {isBulletList && Array.isArray(content) ? (
                            <ul className={styles['proxy-content-list']}>
                                {content.map((item, index) => (
                                    <li key={index} className={styles['proxy-content-list-item']}>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className={styles['proxy-content-text']}>{content}</p>
                        )}
                        {isTablet && <ProxyPromoImage isTablet={isTablet} />}
                    </div>
                </div>
                {!isTablet && <ProxyPromoImage isTablet={isTablet} />}
            </div>
        </section>
    );
};

export default ProxyPromoContent;
